import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Box, styled, Typography } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMemo } from "react";
import Icon from "../icon/Icon";
import { Sizes, Triangle } from "../icon/IconList";
import { useBrandStore } from "./BrandProvider";
import { useBrandQuery } from "./queries/useBrandQuery";
import { isPathMatched, normalizePath } from "./checkPath";
export const BrandLNBPc = (param)=>{
    let { links  } = param;
    const name = useBrandStore((state)=>state.brand.name);
    const { data: brand  } = useBrandQuery({
        name
    });
    var _brand_hasNewNotice;
    const hasNewNotice = (_brand_hasNewNotice = brand === null || brand === void 0 ? void 0 : brand.hasNewNotice) !== null && _brand_hasNewNotice !== void 0 ? _brand_hasNewNotice : false;
    return /*#__PURE__*/ _jsx(StyledNav, {
        children: /*#__PURE__*/ _jsx("ul", {
            children: links.map((link)=>/*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsx(NavigationLink, {
                        link: link,
                        brandName: name,
                        hasNewNotice: hasNewNotice
                    })
                }, link.index))
        })
    });
};
const NavigationLink = (param)=>{
    let { link , brandName , hasNewNotice  } = param;
    const { asPath  } = useRouter();
    const href = link.path(brandName);
    const name = link.name;
    const isActive = useMemo(()=>{
        const current = normalizePath(asPath);
        const target = normalizePath(href);
        return isPathMatched(current, target, link.match);
    }, [
        asPath,
        href,
        link.match
    ]);
    return /*#__PURE__*/ _jsx(StyledLink, {
        href: href,
        onClick: ()=>{
            //mx-188 브랜드홈 메뉴 클릭시
            mixpanelEvent("Brand Menu Clicked", {
                "Brand Name": brandName,
                "Menu Name": name
            });
        },
        className: isActive ? "active" : "",
        children: /*#__PURE__*/ _jsxs(Box, {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: "8px",
                position: "relative"
            },
            children: [
                isActive && /*#__PURE__*/ _jsx(Icon, {
                    icon: Triangle,
                    size: Sizes.small
                }),
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "h6",
                    sx: {
                        position: "relative"
                    },
                    children: [
                        name,
                        hasNewNotice && link.name === "공지" && /*#__PURE__*/ _jsx(StyledNoticeNew, {})
                    ]
                })
            ]
        })
    });
};
const StyledNav = styled("nav")((param)=>{
    let { theme  } = param;
    return {
        width: "320px",
        padding: "20px",
        backgroundColor: theme.palette.grey[0],
        height: "fit-content",
        borderRadius: "12px",
        flexShrink: 0,
        ul: {
            display: "flex",
            flexDirection: "column",
            gap: "4px"
        },
        [theme.breakpoints.down("lg")]: {
            display: "none"
        }
    };
});
const StyledLink = styled(Link)((param)=>{
    let { theme  } = param;
    return {
        padding: "12px 20px",
        display: "block",
        h6: {
            color: theme.palette.text.secondary
        },
        borderRadius: "6px",
        ...theme.typography.h6,
        [":hover"]: {
            backgroundColor: "rgba(169, 175, 199, 0.20)",
            transition: "background-color 0.3s"
        },
        "&.active": {
            h6: {
                color: theme.palette.text.title
            },
            backgroundColor: "rgba(169, 175, 199, 0.20)",
            padding: "12px 14px"
        }
    };
});
export const StyledNoticeNew = styled("span")((param)=>{
    let { theme  } = param;
    return {
        position: "absolute",
        top: "0",
        right: "-8px",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: theme.palette.red[400],
        [theme.breakpoints.down("lg")]: {
            top: "10px"
        }
    };
});
